!customElements.get("op-algolia-moco-picker") && customElements.define("op-algolia-moco-picker", class extends HTMLElement {
    connectedCallback () {
        this.sectionId = this.dataset.sectionId;
        this.shopRoot = window.Shopify?.routes?.root || "/";
        this.groupKey = this.dataset.groupKey;
        this.currentProductHandle = this.dataset.currProductHandle;
        this.hoveringProduct = null;
        this.thumbnails = [];
        this.thumbnailsLimit = parseInt(this.dataset.thumbnailsLimit || "5");
        this.itemTemplate = this.querySelector("[data-moco-picker-item]");
        this.selItemTemplate = this.querySelector("[data-selected-moco-item]");
        this.moreModalBtn = this.querySelector("[data-more-modal-btn]");
        this.moreCountDisplay = this.moreModalBtn?.querySelector("[data-remaining-count]");
        this.hoverImages = document.querySelectorAll('.js-hover-galley-img');
        this.mainGalleryImg = document.querySelector(".js-media-img img");
        this.thumbEnterHandler = this.onThumbMouseEnter.bind(this);
        this.thumbLeaveHandler = this.onThumbMouseLeave.bind(this);
        this.hoverTimer = null;
        this.hits = [];
        this.classicPicker = this.dataset.classicPickerId ? document.getElementById(this.dataset.classicPickerId) : null;
        this.showingClassicPicker = false;
        this.variantImageLabel = this.dataset.variantImageLabel || "Variant Image";

        
        this.thumbnailsFromMetafield = this.querySelectorAll("[data-handle]");

        this.dynamicElements = {
            price: document.querySelector(`#op-main-price-${this.sectionId}`),
            compareAtPrice: document.querySelector(`#op-main-compare-${this.sectionId}`),
            frame: document.querySelector(`#js-frame-info-${this.sectionId} .subtitle`),
            lens: document.querySelector(`#js-lens-info-${this.sectionId} .subtitle`),
        }

        this.compareWrappers = document.querySelectorAll(`.js-compare-wrapper-${this.sectionId}`);
        this.promoBadges = document.querySelectorAll(`.js-promoBadge-${this.sectionId}`);

        this.mobileDesktopLimit = parseInt(this.dataset.mdLimit || "4");
        this.tabletLimit = parseInt(this.dataset.tbLimit || "6");
        this.mqTablet = window.matchMedia("(min-width: 768px) and (max-width: 1023.98px)");

        this.setLimitByViewport = () => {
            this.thumbnailsLimit = this.mqTablet.matches ? this.tabletLimit : this.mobileDesktopLimit;
        };

        this.onViewportChange = () => {
            const prev = this.thumbnailsLimit;
            this.setLimitByViewport();
            if (prev !== this.thumbnailsLimit) this.renderThumbs();
        };

        this.setLimitByViewport();
        this.mqTablet.addEventListener?.("change", this.onViewportChange);

        if (this.groupKey) {
            this.loadGroupItems();
        }
    }

    disconnectedCallback () {
        this.clearThumbs();
    }

    clearThumbs () {
        this.thumbnails.forEach(thumb => thumb.remove());
        this.thumbnails.length = 0;
    }

    ensureTemplateLoaded (container, templateSelector, loadedKey) {
        if (!container || container.dataset?.[loadedKey] === "true") return;

        const template = container.querySelector(templateSelector);
        if (!template) return;

        container.appendChild(template.content.cloneNode(true));
        template.remove();
        container.dataset[loadedKey] = "true";
    }

    ensureThumbImageLoaded (thumb) {
        this.ensureTemplateLoaded(thumb, "template[data-moco-image-template]", "mocoImageLoaded");
        this.normalizeThumbAlt(thumb);
    }

    normalizeLegacyVariantSuffix (value) {
        if (!value || !this.variantImageLabel) return value;

        const normalizedSuffix = ` - ${this.variantImageLabel}`;
        const trimmedValue = value.trim();

        if (trimmedValue.endsWith(normalizedSuffix)) return trimmedValue;

        const cleanedValue = trimmedValue
            .replace(/\s-\sVariant Image\s*$/i, "")
            .replace(/\s-\sVariant\s*$/i, "");

        return cleanedValue === trimmedValue ? trimmedValue : `${cleanedValue}${normalizedSuffix}`;
    }

    normalizeThumbAlt (thumb) {
        if (!thumb) return;

        const ariaLabel = thumb.getAttribute("aria-label");
        if (ariaLabel) {
            thumb.setAttribute("aria-label", this.normalizeLegacyVariantSuffix(ariaLabel));
        }

        const image = thumb.querySelector("img");
        if (image?.hasAttribute("alt")) {
            image.setAttribute("alt", this.normalizeLegacyVariantSuffix(image.getAttribute("alt")));
        }
    }

    filterHits (hits = []) {
        const handleSet = new Set();
        const filteredHits = [];

        for (const hit of hits) {
            if (handleSet.has(hit.handle)) {
                continue;
            }

            filteredHits.push({
                handle: hit.handle,
                id: hit.id,
                image: hit.image,
                inventory_available: hit.inventory_available,
                objectID: hit.objectID,
                title: hit.title,
            });

            handleSet.add(hit.handle);
        }

        return filteredHits;
    }

    formatImageUrl (url, width, height) {
        const parsedUrl = URL.parse(url, window.location.origin);

        if (!parsedUrl) {
            console.error("Invalid URL:", url);
            return url;
        }

        if (width) {
            parsedUrl.searchParams.set("width", width);
        }

        if (height) {
            parsedUrl.searchParams.set("height", height);
        }

        return parsedUrl.toString();
    }

    loadGroupItems () {
        let hitsFound = false;

        try {
            const lastGroup = JSON.parse(sessionStorage.getItem("lastGroupItem"));
            const lastHits = lastGroup?.hits;

            if (Array.isArray(lastHits) && lastGroup.xGroupKey === this.groupKey) {
                this.hits = lastHits;
                //this.renderThumbs();
                hitsFound = true;
            }

            this.renderThumbs();
        }
        catch (error) {
            console.error("Error parsing lastGroupItem session storage:", error);
        }

        
        //this.toggleClassicPicker(!hitsFound);
    }

    onThumbMouseEnter (event) {
        const handle = event.currentTarget.dataset.handle;
        
        if (this.currentProductHandle !== handle) {
            this.hoveringProduct = true;
    
            clearTimeout(this.hoverTimer);
            this.reduceElementsOpacity(true);
    
            this.hoverTimer = setTimeout(() => {
                this.updateProductInfo(handle, event.currentTarget);
                this.reduceElementsOpacity(false);
            }, 300);
        }
    }

    onThumbMouseLeave () {
        if (this.hoveringProduct) {
            clearTimeout(this.hoverTimer);
            this.hoverTimer = null;
            this.hoveringProduct = false;
    
            this.reduceElementsOpacity(true);
    
            this.hoverTimer = setTimeout(() => {
                const currentThumb = this.querySelector(`[data-handle="${this.currentProductHandle}"]`);
                this.updateProductInfo(this.currentProductHandle, currentThumb);
                this.reduceElementsOpacity(false);
            }, 300);
        }
    }

    reduceElementsOpacity (status) {
        for (let key in this.dynamicElements) {
            const el = this.dynamicElements[key];

            if (el) {
                status ? el.style.opacity = 0.5 : el.style.removeProperty("opacity");
            }
        }
    }

    attachThumbListeners (thumbnails = []) {
        thumbnails.forEach((thumb) => {
            if (thumb?.dataset?.hoverListenersAttached === "true") return;

            thumb.addEventListener("mouseenter", this.thumbEnterHandler);
            thumb.addEventListener("mouseleave", this.thumbLeaveHandler);
            thumb.dataset.hoverListenersAttached = "true";
        });
    }

    renderThumbs () {
        if (!this.itemTemplate) {
            console.error("Template not found in the component.");
            return;
        }

        const showMoreModalBtn = (thumbLength, showCount) => {
            if (this.moreModalBtn) {
                const remaining = Math.max(thumbLength - showCount, 0);
                if (remaining > 0) {
                    if (this.moreCountDisplay) {
                        this.moreCountDisplay.textContent = remaining;
                        this.moreModalBtn.style.removeProperty("display");
                        this.appendChild(this.moreModalBtn);
                    } else {
                        this.moreModalBtn.style.display = "none";
                    }
                }
            }
        }

        /*
         * This block is responsible for rendering product thumbnails
         * in the picker component, adapting the displayed items depending 
         * on whether search results ("hits") exist.
         *
         * If there are no hits (Algolia did not match any products), it:
         *   - Determines the total number of thumbnails available from the metafield.
         *   - Limits the thumbnails to either their total count or a defined maximum (thumbnailsLimit).
         *   - Slices the available thumbnails to display only the first 4.
         *   - Iterates through these thumbnails and appends each to the picker component.
         *   - Calls `clearThumbs()` to clear any additional thumbnail display state.
         *   - Calls `showMoreModalBtn()` to potentially reveal a "Show More" button if not all items fit.
         *
         * If there are hits (matching products from Algolia search), this block:
         *   - Builds an array of product handles from the hits to establish the correct display order.
         *   - Sorts all thumbnails according to that order; thumbnails not found in hits are sent to the end.
         *   - Slices the sorted array to display a maximum of 4 thumbnails.
         *   - Appends each sorted and selected thumbnail to the picker component.
         *   - Calls `showMoreModalBtn()` to handle display of "Show More" if there are more hits than the limit.
         *
         * This block is crucial for dynamically updating the thumbnail visuals based on whether products were
         * fetched with Algolia or not, ensuring prioritized and limited visual representation of available products
         * and providing an entry point for displaying additional items via a modal if necessary.
         */
        let thumbnailsToRender = [];

        if(!this.hits || this.hits.length === 0) {
            const thumbLength = this.thumbnailsFromMetafield.length;
            const showCount = Math.min(thumbLength,this.thumbnailsLimit);
            thumbnailsToRender = Array.from(this.thumbnailsFromMetafield).slice(0, showCount);
            thumbnailsToRender.forEach((thumbnail) => {
                this.appendChild(thumbnail);
                this.ensureThumbImageLoaded(thumbnail);
            });
            this.clearThumbs();
            showMoreModalBtn(thumbLength, showCount);
         
        } else {

            const handleOrder = this.hits.map(hit => hit.handle);
            let sortedThumbnails = Array.from(this.thumbnailsFromMetafield).sort((a, b) => {
                const handleA = a.dataset.handle;
                const handleB = b.dataset.handle;
                const idxA = handleOrder.indexOf(handleA);
                const idxB = handleOrder.indexOf(handleB);
                return (idxA === -1 ? Number.MAX_SAFE_INTEGER : idxA) - (idxB === -1 ? Number.MAX_SAFE_INTEGER : idxB);
            });
            
            thumbnailsToRender = sortedThumbnails.slice(0, this.thumbnailsLimit);
            thumbnailsToRender.forEach((thumbnail) => {
                this.appendChild(thumbnail);
                this.ensureThumbImageLoaded(thumbnail);
            });
            const showCount = Math.min(this.hits.length, this.thumbnailsLimit);
            showMoreModalBtn(this.hits.length, showCount);
        }

        this.attachThumbListeners(thumbnailsToRender);
    }

    toggleClassicPicker (status) {
        if (this.classicPicker) {
            this.classicPicker.style.display = status ? "block" : "none";
            status ? this.style.display = "none" : this.style.removeProperty("display");
            this.showingClassicPicker = status;
        }
    }

    updateProductInfo (handle, thumbElement) {
        const thumbnail = thumbElement || this.querySelector(`[data-handle="${handle}"]`);

        if (this.mainGalleryImg && thumbnail?.dataset?.srcset) {
            this.mainGalleryImg.setAttribute("srcset", thumbnail.dataset.srcset);
            this.mainGalleryImg.setAttribute("src", thumbnail.dataset.srcset);
        }

        let hoverElement;

        for (let el of this.hoverImages) {
            const isCurrent = el.dataset.productHandle === handle;
            el.style.opacity = isCurrent && handle !== this.currentProductHandle ? 1 : 0;

            if (isCurrent) {
                hoverElement = el;
            }
        }
        
        if (!hoverElement) return;

        if (this.dynamicElements.price) this.dynamicElements.price.textContent = hoverElement.dataset.price;
        if (this.dynamicElements.compareAtPrice) this.dynamicElements.compareAtPrice.textContent = hoverElement.dataset.compare || '';
        if (this.dynamicElements.lens) this.dynamicElements.lens.textContent = hoverElement.dataset.lens || '';
        if (this.dynamicElements.frame) this.dynamicElements.frame.textContent = hoverElement.dataset.frame || '';

        this.compareWrappers.forEach(el => el.style.display = hoverElement.dataset.compare ? 'flex' : 'none');
        this.promoBadges.forEach(el => el.textContent = hoverElement.dataset.promoBadge?.trim() || '');
    }
});